import '../../App.css';
import React, {Component, Container} from 'react';
import {Image,Navbar, Nav, NavItem, NavDropdown, Dropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import NavBarTop from "./navbar";
import Footer from "./footer";
//import PaypalCheckoutButton from './elements/paypaylcheckout';
import PaypalCheckoutBtn from './elements/paypalcheckout';
import pricelist from '../../pricelist';
import { type } from '@testing-library/user-event/dist/type';


const applyurl="https://docs.google.com/forms/d/e/1FAIpQLSeHmQ8_mwRCxNSYtfLEq6oSWSmiNxbWZSuwHdE2AUAqzwM1uQ/viewform?usp=publish-editor" //2026
const content = {
  "en":{
        "title":"Our Services", 
        "content": "Hicus' businesses focus on digital currency, spot gold trading and clearing, digital currency, and spot gold. Market data and information, social networking and corporate services are also our vital components. Through Hicus, we provide high-quality personal online investment services to global investors, as well as corporate services such as asset management to many corporate customers. \nDigital currency, spot gold trading and settlement\nWe provide users with digital currency, spot gold and foreign exchange investment transactions through our self-developed one-stop digital financial services. Users can apply online to open an account and get instant access to market information, you can also enjoy millisecond-level fast trading experience. \nWealth Management\nWealth is Hicus' wealth management brand and currently provides top investment services from around the world. At present, all investment products have redemption fees, and the investment threshold is extremely low. Users can monitor positions in real time, track the performance of digital currency assets, and learn about digital currency and spot gold information, including product duration, main positions, and the geographical and industry distribution of positions. Hicus seamlessly opens up customers' investment accounts and wealth management accounts, providing customers with a convenient one-stop asset allocation platform. \nMarket data and information\nBased on transaction settlement and investment business, we also provide real-time market data for all three major markets of digital currency, spot gold, and foreign exchange. At the same time, it provides rich and comprehensive financial information, research reports and advanced and intuitive analysis tools to enhance the investment experience of users and customers and help customers make more accurate investment decisions while grasping industry trends. \nSocial\nServing the community through social networks, we expand our reach and facilitate the exchange of information. We creatively embed social media tools to create a user-centric social network that better connects users, investors, companies, analysts, media and opinion leaders. This helps facilitate the free flow of information, reduces information asymmetry and aids the investment decision-making process. For example, users can share market views at any time, watch company events live, and participate in investment education courses offered by Hicus' Educational Platforms.",
        "title2":"Our Products",
        "content2": "As a one-stop digital financial service company, Hicus is a one-stop digital financial service platform dedicated to excellent experience of digital currency, spot gold and foreign exchange. Investors are provided with the most stable and fast trading experience. Investors can enjoy high-quality one-stop investment services on Hicus, and at the same time exchange investment knowledge and master investment skills with investors from all over the world through Hicus."  
      },
  "zh":{
        "title":"我們的業務", 
        "content": "海克斯的業務以數字貨幣、現貨黃金交易和清算、數字貨幣、現貨黃金為主，市場數據及資訊、社交以及企業服務亦是其重要組成部分。通過海克斯不僅面向全球投資者提供優質的個人線上投資服務，並面向眾多企業客戶提供資產管理等企業服務。\n數字貨幣、現貨黃金交易與結算\n我們通過自主研發的一站式數字化金融服務，向用戶提供數字貨幣、現貨黃金、外匯三大市場的投資交易，用戶可以通過線上申請開戶，即時獲取行情資訊，還能享受毫秒級的極速交易體驗。\n財富管理\n財富是海克斯的財富管理品牌，目前提供來自全球頂尖投資服務。目前所有投資產品贖回費，且投資門檻極低。用戶可以實時監控倉位，追踪數字貨幣資產業績，以及了解數字貨幣以及現貨黃金的各項信息，包括産品久期、主要持倉、持倉的地域和行業分佈等。海克斯無縫打通了客戶的投資賬戶和財富管理賬戶，爲客戶提供了便捷的一站式資産配置平台。\n市場數據及資訊\n基於交易結算和投資業務，我們還面向所有數字貨幣、現貨黃金、外匯三大市場的即時行情數據。同時提供豐富全面的財經資訊、研究報告以及先進直觀的分析工具，以增強用戶及客戶的投資體驗，幫助客戶在掌握行業動態的同時，做出更準確的投資決策。\n社交\n通過社交網絡服務社區，我們擴大了業務範圍並促進信息交流。我們創造性地嵌入社交媒體工具，創建一個以用戶為中心的社交網絡，從而更好地連接用戶、投資者、公司、分析師、媒體和意見領袖。這有助於促進資訊的自由流動，減少資訊不對稱並幫助投資決策過程。例如，用戶可以隨時分享市場觀點，觀看公司活動直播，參加海克斯課堂提供的投資教育課程。",
        "title2":"我們的產品",
        "content2": "一站式數字化金融服務公司，海克斯是一款傾心于超卓體驗數字貨幣、現貨黃金、外匯一站式數字化金融服務平台，集行情、交易、資訊、海克斯可以為身處世界各地的投資者提供最穩定快速的交易體驗。投資者可以在海克斯上享受著優質的一站式投資服務，同時通過海克斯與各地投資者交流投資知識、掌握投資技巧。"
    },
  "cn":{
        "title":"我们的业务", 
        "content": "海克斯的业务以数字货币、现货黄金交易和清算、数字货币、现货黄金为主，市场数据及资讯、社交以及企业服务亦是其重要组成部分。通过海克斯不仅面向全球投资者提供优质的个人线上投资服务，并面向众多企业客户提供资产管理等企业服务。 \n数字货币、现货黄金交易与结算\n我们通过自主研发的一站式数字化金融服务，向用户提供数字货币、现货黄金、外汇三大市场的投资交易，用户可以通过线上申请开户，即时获取行情资讯，还能享受毫秒级的极速交易体验。 \n财富管理\n财富是海克斯的财富管理品牌，目前提供来自全球顶尖投资服务。目前所有投资产品赎回费，且投资门槛极低。用户可以实时监控仓位，追踪数字货币资产业绩，以及了解数字货币以及现货黄金的各项信息，包括产品久期、主要持仓、持仓的地域和行业分布等。海克斯无缝打通了客户的投资账户和财富管理账户，为客户提供了便捷的一站式资产配置平台。 \n市场数据及资讯\n基于交易结算和投资业务，我们还面向所有数字货币、现货黄金、外汇三大市场的即时行情数据。同时提供丰富全面的财经资讯、研究报告以及先进直观的分析工具，以增强用户及客户的投资体验，帮助客户在掌握行业动态的同时，做出更准确的投资决策。 \n社交\n通过社交网络服务社区，我们扩大了业务范围并促进信息交流。我们创造性地嵌入社交媒体工具，创建一个以用户为中心的社交网络，从而更好地连接用户、投资者、公司、分析师、媒体和意见领袖。这有助于促进资讯的自由流动，减少资讯不对称并帮助投资决策过程。例如，用户可以随时分享市场观点，观看公司活动直播，参加海克斯课堂提供的投资教育课程。",
        "title2":"我们的产品",
        "content2":"一站式数字化金融服务公司，海克斯是一款倾心于超卓体验数字货币、现货黄金、外汇一站式数字化金融服务平台，集行情、交易、资讯、海克斯可以为身处世界各地的投资者提供最稳定快速的交易体验。投资者可以在海克斯上享受着优质的一站式投资服务，同时通过海克斯与各地投资者交流投资知识、掌握投资技巧。"
    },
}

const forex = {
  "USD/HKD": 8.02,
  "EUR/HKD": 7.97,
}

class Apply extends Component {
  constructor(props){
    super(props);
    this.state = {  
       chosengroup:null,
       chosenprice:"string",
       USDprice:null,
       applicantName:"",
       product:{},
    };
    this.changeValue = this.changeValue.bind(this)
    this.callback = this.callback.bind(this)
    this.changecurrency = this.changecurrency.bind(this)
    this.changeName = this.changeName.bind(this)
    this.setval = this.setval.bind(this)
    this.clickapply = this.clickapply.bind(this)
  }
  componentDidMount(){
    document.title="International Young Artist Open Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/iyao_logo.png"
    link2.href="/assets/iyao_logo.png"
    this.props.setval({comp:"iyao"})  
  }
  setval(obj){
    this.setState(obj)
  }
  changeName(e){
    const chosene = e.target.value.toUpperCase();
    this.setState({applicantName:chosene})

  }
  changecurrency(e,curr){
    this.props.setval({chosencurrency:curr})
    this.callback(curr)
  }
  callback(curr){
    const list = JSON.parse(JSON.stringify(pricelist))
    var price = list[this.state.chosengroup]
    if((price!=undefined && price!==NaN)){
      //alert(price)
      if(curr==="USD"){
        // price =  Math.round(price*100/forex["USD/HKD"])/100
      } else if (curr==="EUR" && (price!=undefined && price!==NaN)){
        price =  Math.round(price*100/forex["EUR/HKD"])/100
      } else if(price==undefined || price==NaN){
        price = "string"
      }
    }
    const product1 = {
      description: "IYAO Compeition - "+this.state.chosengroup,
      price: price.toString()
    }
    
    this.setState({chosenprice:price,product:product1})
  }
  changeValue(e,curr){
    const list = JSON.parse(JSON.stringify(pricelist))
    const chosene = e.target.value.toUpperCase()
    var price = list[chosene]
   
    //alert(price)
    if (this.props.chosencurrency==="USD" && (price!=undefined && price!==NaN)){
      // price =  Math.round(price *100/forex["USD/HKD"])/100
      //alert(price)
    } else if (this.props.chosencurrency==="EUR" && (price!=undefined && price!==NaN)){
      price =  Math.round(price*100/forex["EUR/HKD"])/100
    } else if(price==undefined || price==NaN){
      price = "string"
    }
    const product1 = {
      description: "IYAO Compeition - "  +this.state.applicantName + " : " + chosene,
      price: price.toString()
    }
    // alert(JSON.stringify(product1))
    
    //this.props.setval({chosencurrency:curr})
    this.setState({chosengroup:chosene,chosenprice:price,USDprice:product1.price,product:product1})

  }
  changeCustomValue(e,curr){
    const chosene = e.target.value.toUpperCase()
    const group = this.state.chosengroup
    var price = null

    if (this.props.chosencurrency==="USD" && (chosene!=undefined && chosene!==NaN)){
      price = parseInt(chosene) //Math.round(price *100/forex["USD/HKD"])/100
      // alert(price)
    } else if (this.props.chosencurrency==="EUR" && (price!=undefined && price!==NaN)){
      price =  Math.round(chosene*100/forex["EUR/HKD"])/100
    } else if(price==undefined || price==NaN){
      price = "string1"
    }
    const product1 = {
      description: "IYAO Compeition - CUSTOM",
      price: price.toString()
    }
    this.setState({chosengroup:group,chosenprice:price,USDprice:product1.price,product:product1})

  }
  clickapply(){
    window.open(applyurl, '_blank', 'noopener,noreferrer');
}

  render(){
    return (
      <div>
       
       <div><img src="/assets/apply.png" alt="" width="100%" height="" style={{borderRadius:"0px"}} /></div>
      <div style={{display:"flex",flexDirection:"column",paddingLeft:"8%",paddingRight:"8%",paddingTop:"6%",paddingBottom:"2%",textAlign:"left"}}>
      
        <h2 style={{fontFamily:"Courgette"}}>2026 International Young Artist Open Competition</h2>
        <h4 style={{fontFamily:"Courgette"}}>Deadline: 15th November 2026</h4>
        <h4 style={{fontFamily:"Courgette"}}>Tentative Result Date: 15th December 2026</h4>
        <br/>
        
        {/* <table style={{fontFamily:"Courgette"}}>
          <tbody><tr>
          <td className="apply-payment-boxtitle">&nbsp;&nbsp;FPS(轉數快) Phone No.</td>
          <td className="apply-payment-boxcontent">&nbsp;&nbsp; 6204 0873</td>
          </tr></tbody>
          </table> */}

          {/* <table style={{fontFamily:"Courgette"}}>
          <tbody><tr>
          <td className="apply-payment-boxtitle">&nbsp;&nbsp;Bank / ATM Transfer (Bank Of China)</td>
          <td className="apply-payment-boxcontent">&nbsp;&nbsp;012-917-1-133753-2</td>
          </tr></tbody>
          </table>
          <br></br> */}

          <h4 className="apply-body-font" style={{fontFamily:"Courgette",textAlign:"justify",marginBottom:"3%"}}>
            Please make sure you know your <a style={{color:"rgba(212,190,55,1)",fontStyle:"italic"}} href="/iyao/category"><u>Group Number</u></a> and have your payment proof (eg. Transfer Receipt) photo ready before applying<sup>1</sup>.</h4>

          <h4 className="apply-body-font" style={{fontFamily:"Courgette",textAlign:"justify"}}>The video requirements will be explained in the confirmation email which will be sent after successful application<sup>2</sup>.</h4>
          
          <br></br>
          <div style={{display:"flex",flexDirection:"column",alignItems:"left",padding:"5px",border:"1px solid white",background:"rgba(255,255,255,0.9)",paddingLeft:"5%",paddingRight:"5%",color:"#1c1f1d",borderRadius:"10px"}}>
            
            <h2  style={{marginLeft:"1%",marginTop:"2%",marginBottom:"3%"}}>Pay now with Credit Card or PayPal 
              <p style={{fontSize:"0.56em",textAlign:"justify"}}>*Service charge may be applied. Please double check your amount in the paypal pop-up window. Remember to take a screenshot after successful payment. 
                If you forgot, you may take a screenshot of your payment receipt email from PayPal.</p></h2>
            
            <label style={{marginLeft:"1.7%"}}><h3 style={{fontSize:"1.2em"}}>Applicant Name &nbsp;&nbsp; 
            <input style={{width:"60vw"}} type="text" name="Applicant Name" onChange={(e)=>{
              this.changeName(e)
              }} />
            </h3>
             </label>

            <label style={{marginLeft:"2%"}}><h3 style={{fontSize:"1.2em"}}>Group Number &nbsp;&nbsp;&nbsp; 
            <input style={{width:"60vw"}} type="text" name="Competition Group" onChange={(e)=>{
              this.changeValue(e)
              }} />
            </h3>
             </label>

             {((this.state.chosengroup=="CUSTOM") && (this.state.chosenprice!=="string1")) && <label style={{marginLeft:"2%"}}><h3 style={{fontSize:"1.2em"}}>Custom Amount&nbsp;&nbsp; 
            <input style={{width:"60vw"}} type="text" name="Custom Payment Amount" onChange={(e)=>{
              this.changeCustomValue(e)
              }} />
            </h3>
             </label>}

             
            
            <label>
            {/* {<Dropdown style={{marginLeft:"3%",marginTop:"1.5%",marginRight:"3%",float:"left"}}>
              <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                {this.props.chosencurrency}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={(e)=>{
                  this.changecurrency(e,"HKD")
                  }}>HKD</Dropdown.Item>
                <Dropdown.Item onClick={(e)=>{
                  this.changecurrency(e,"USD")
                  }}>USD</Dropdown.Item>
                <Dropdown.Item onClick={(e)=>{
                  this.changecurrency(e,"EUR")
                  }}>EUR</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>} */}
                {
                  ((typeof(this.state.chosenprice)=="string")) && 
                  <h4 style={{marginTop:"2%",marginLeft:"2%"}}>
                    <i>{"Please input a correct group number"}</i></h4>
                }
                {
                  ((typeof(this.state.chosenprice)=="number")) && 
                  <h3 style={{marginTop:"2%",marginLeft:"2%",marginRight:"2%"}}>
                    <i>{"Application Fee : USD "+this.state.chosenprice}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <h6 style={{fontSize:"0.65em",textAlign:"justify",marginRight:"7%"}}>*You might be able to pay in other currencies. Please check your options after pressing the pay buttons below.</h6></h3>
                }
              
            </label>

            <div style={{marginTop:"3%",marginLeft:"10%",marginRight:"10%"}}>
         {/* { <PaypalCheckoutButton  product={{description:"IYAO",price:52}}/>} */}
         <PaypalCheckoutBtn {...this.state}/>
          </div>

          </div>



            <div style={{marginTop:"3%"}}>
           <h6 className="apply-body-font" style={{fontFamily:"Courgette",textAlign:"justify",marginTop:"4%"}}>For alternative payment methods, please <a href="mailto:iyaocompetition@gmail.com?subject=Payment%20Enquiry%20from%20website&amp;body=Dear IYAO,">
                   email
                    </a> us.</h6>
            </div>

          <div style={{marginTop:"7%"}}>
          <h4 className="apply-body-font" style={{fontFamily:"Courgette"}}>If you have your payment receipt, you may now click the button below and fill in your application.</h4>
          </div>
          
          <a onClick={(e)=>{this.clickapply()}}><button id="goldbutton-apply" style={{fontSize:"160%",width:"50%"}} >
          APPLY NOW</button></a>
          <br></br>

          <h4 className="apply-body-font" style={{fontFamily:"Courgette",textAlign:"justify",marginTop:"4%"}}>For further technical issues, please <a href="mailto:iyaocompetition@gmail.com?subject=Enquiry%20from%20website&amp;body=Dear IYAO,">
                   email
                    </a> us.</h4>
        {/* <Form>
        <div><h4>Personal Information</h4></div>
      <Form.Group className="mb-3" controlId="fullname">
        <Form.Label style={{textAlign:"left"}}>Contestant Full Name in English</Form.Label>
        <Form.Control type="text" placeholder="" />
        <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text> 
      </Form.Group>

      <Form.Group className="mb-3" controlId="gender">
      <Form.Label style={{textAlign:"left"}}>Gender</Form.Label>
      <Form.Select>
        <option>Male</option>
        <option>Female</option>
      </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Date of Birth</Form.Label>
        <Form.Control type="date" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Email</Form.Label>
        <Form.Cofntrol type="email" placeholder="example@abc.com" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Tel / Mobile</Form.Label>
        <Form.Control type="number" placeholder="" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Teacher's Full Name in English</Form.Label>
        <Form.Control type="text" placeholder="" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Teacher's Contact Number</Form.Label>
        <Form.Control type="number" placeholder="" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>ID Document</Form.Label>
        <Form.Control type="file" accept=".pdf,.docx,.doc,.jpg,.png" placeholder="Please upload your ID document here." />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Proof of Payment</Form.Label>
        <Form.Control type="file" accept=".pdf,.docx,.doc,.jpg,.png" placeholder="Please upload your payment receipt here." />
      </Form.Group>

      <div>&nbsp;<h4>Instrument and Repertoire</h4></div>
      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Instrument Category</Form.Label>
        <Form.Select aria-label="Default select example">
          <option>Please select one from dropdown</option>
          <option value="1">Piano</option>
          <option value="2">String</option>
          <option value="3">Voice</option>
          <option value="4">Woodwind</option>
          <option value="5">Brass</option>
          <option value="6">Recorder</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob" style={{display:"block"}}>
        <Form.Label><div style={{float:"left"}}>Competition Group Number&nbsp;&nbsp;&nbsp;</div> <p style={{float:"left"}}>{"( Click"}&nbsp;&nbsp;</p>
        <a style={{float:"left",cursor:"pointer"}} onClick={(e)=>{
          alert("button clicked")
        }}><u>HERE</u></a><p style={{float:"left"}}>&nbsp;&nbsp;if you don't know your group.{" )"}</p></Form.Label>
        <Form.Control type="text" placeholder="P21" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>Piece's Name - Composer</Form.Label>
        <Form.Control type="text" placeholder="Andante (No. 2 from For Children, Vol. 2) - Bartók" />
      </Form.Group>
      <br/>

      <Form.Group className="mb-3" controlId="dob">
        <Form.Label>How did you know about our competition?</Form.Label>
        <Form.Check type={"checkbox"} id={"fbpage"} label={"Facebook Page"} />
        <Form.Check type={"checkbox"} id={"igpage"} label={"Instagram Page"} />
        <Form.Check type={"checkbox"} id={"trecom"} label={"Teacher's Recommendation"} />
        <Form.Check type={"checkbox"} id={"friend"} label={"Heard from griends or other parents"} />
        <Form.Check type={"checkbox"} id={"other"} label={"Others"} />
      </Form.Group>
        <br/>
      <Button variant="primary" onClick={(e)=>{
        alert("submitted")
      }}>
        Submit
      </Button>
    </Form> */}

      <br/><br/>
    <h6 style={{fontSize:"0.85em",fontFamily:"Courgette"}}><sup>1</sup>After successful payment, we will send a confirmation email to you.</h6>
    <p style={{fontSize:"0.85em",fontFamily:"Courgette"}}><sup>2</sup>All application fees are non-refundable.</p>
      </div>
      </div>
    );
  }
  }
  

export default Apply;
